import { cn } from "@/utils/cn";

export function BetaPill({ className }: { className?: string }) {
  return (
    <span
      className={cn(
        "inline-flex shrink-0 rounded-full border border-primary px-2 text-xs font-semibold uppercase leading-5 tracking-wide text-primary",
        className
      )}
    >
      Beta
    </span>
  );
}
